module.exports = __webpack_public_path__ + "img/ico-close.8cef2f64.svg";